import { atom } from 'jotai';
import { IArticleUnavailableDetail, TArticleDetail } from '../../models';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { Unreachable } from '@lemon8/web-app-shared/util';

type ArticleDetailAtomValue = TArticleDetail | IArticleUnavailableDetail;

export const $ArticleDetailStore = atom<Record<string, ArticleDetailAtomValue | undefined>>({});

export const $ArticleDetail = safeAtomFamily((groupId: string) => {
  const a = atom<ArticleDetailAtomValue, [ArticleDetailAtomValue], void>(
    (get) => {
      const data = get($ArticleDetailStore)[groupId];
      if (!data) {
        return Unreachable(`$ArticleDetail(${groupId}) not found`);
      }
      return data;
    },
    (get, set, newArticle) => {
      const old = get($ArticleDetailStore);
      set($ArticleDetailStore, { ...old, [groupId]: newArticle });
    },
  );

  a.debugLabel = `$ArticleDetail+${encodeURIComponent(groupId)}`;

  return a;
});
